import { render, staticRenderFns } from "./envelope-recipient.vue?vue&type=template&id=65ad04bb"
import script from "./envelope-recipient.vue?vue&type=script&lang=js"
export * from "./envelope-recipient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports